export const selectedStateStyles = {
  bg: 'bg.selected',
  color: 'text.selected',
  border: 'none',
};
